import { MultiSelectField } from 'lib/iterable-hook-form/FormField';
import { MessageMedium } from 'constants/messageMediums';
import styled from 'styled-components';
import { BaseOption } from 'ui/selects';
import { spacing, subtitle2 } from 'ui/theme';
import { getMediumIcon } from 'utils/messageMediums';
import { MAX_SELECTED } from './Metrics.constants';

const SelectWrapper = styled.div`
  margin-bottom: ${spacing.plusHalf};
`;

const Medium = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
  margin-bottom: ${spacing.half};
  ${subtitle2}
`;

type DropdownProps = {
  categories: Record<string, string | number>;
  medium: MessageMedium;
  name: string;
  isDisabled?: boolean;
  options: BaseOption[];
};

export const MediumDropdown = ({
  categories,
  medium,
  name,
  options,
  isDisabled = false,
}: DropdownProps) => {
  const Icon = getMediumIcon(medium);
  return (
    <SelectWrapper data-test={`${medium}-metric-select`}>
      <Medium>
        <Icon width={16} />
        {medium}
      </Medium>
      <MultiSelectField
        id="multi-select-metrics"
        optionLimit={MAX_SELECTED}
        isDisabled={isDisabled}
        name={name}
        options={options || []}
        categoryLabels={categories || {}}
      />
    </SelectWrapper>
  );
};
